module.exports = __webpack_public_path__ + "img/historia_3-4_1536.5bc3c925.jpg";